
import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import { getTrans as t } from "../../../Localization/translations";
import Helper from "../../../Helper";

function AllProcessingFailureLog() {

    const tableRef = React.createRef();
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        loadProcessingFailures();
    }, []);

    const loadProcessingFailures = async () => {
        try {

            setIsLoading(true);

            const res = await axios.get(API + "processing/processing-failure-logs/", {
                headers: authHeader(),
            });

            let rowData = res.data || [];
            if (!Array.isArray(rowData)) rowData = [];

            setData(rowData);
            setIsLoading(false);

        } catch (error) {

            console.error("Error loading processing failure logs:", error);
            setIsLoading(false);

        }
    };

    return (
        <div className="page-wrapper">

            <div className="content container-fluid">

                <div className="row">

                    <div className="col-md-12">

                        <MaterialTable
                            tableRef={tableRef}
                            isLoading={isLoading}
                            style={{
                                backgroundColor: "var(--bs-table-bg)",
                                borderBottomWidth: "1px",
                                boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                            }}
                            title={<h5 className="mb-0">{t("Processing Failure Log")}</h5>}

                            columns={[

                                {
                                    title: t("Request ID"),
                                    field: "request_id",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                },
                                {
                                    title: t("Process Name"),
                                    field: "process_name",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                    render: (rowData) => (
                                        rowData.process_name === "Billing" ? "Generate Invoices"
                                            : rowData.process_name === "Notification" ? "Generate Notifications"
                                            : rowData.process_name === "Bucket" ? "Generate Aging Bucket"
                                            : rowData.process_name === "Contract Bulk Create" ? "Contract Bulk Create(QuickFi)"
                                            : rowData.process_name
                                    ),
                                },
                                {
                                    title: t("Step"),
                                    field: "step_name",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                    render: (rowData) => rowData.step_name || "-",
                                },
                                {
                                    title: t("Contract"),
                                    field: "contract_number",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                    render: (rowData) => rowData.contract_number || "-",
                                },
                                {
                                    title: t("Invoice"),
                                    field: "invoice_number",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                    render: (rowData) => rowData.invoice_number || "-",
                                },
                                {
                                    title: t("Type"),
                                    field: "error_type",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                    render: (rowData) => (
                                        <div
                                            className={
                                                rowData.error_type === "Skipped"
                                                    ? "badge badge-sm bg-gradient-secondary"
                                                    : "badge bg-gradient-danger text-xxs"
                                            }
                                        >
                                            {rowData.error_type || "Error"}
                                        </div>
                                    ),
                                },
                                {
                                    title: t("Message"),
                                    field: "error_message",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12, maxWidth: 320 },
                                    render: (rowData) => (
                                        <div
                                            title={rowData.error_message}
                                            style={{
                                                maxWidth: 320,
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {rowData.error_message}
                                        </div>
                                    ),
                                },
                                {
                                    title: t("Requested By"),
                                    field: "requested_by",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                    render: (rowData) => rowData.requested_by || "-",
                                },
                                {
                                    title: t("Created At"),
                                    field: "created_at",
                                    headerStyle: { fontWeight: "bold", textAlign: "left" },
                                    cellStyle: { textAlign: "left", fontSize: 12 },
                                    render: (rowData) => (
                                        <div>
                                            {Helper.DateTimeNormal
                                                ? Helper.DateTimeNormal(rowData.created_at)
                                                : rowData.created_at}
                                        </div>
                                    ),
                                },

                            ]}
                            data={data || []}

                            options={{
                                headerStyle: {
                                    backgroundColor: "white",
                                    color: "#245C7F",
                                    fontSize: 12,
                                },
                                rowStyle: (rowData, index) => ({
                                    backgroundColor: index % 2 ? "#fff" : "inherit",
                                }),
                                search: true,
                                paging: true,
                                pageSize: 10,
                                pageSizeOptions: [10, 20, 25, 50],
                                paginationType: "stepped",
                                showFirstLastPageButtons: false,
                                emptyRowsWhenPaging: false,
                                actionsColumnIndex: -1,
                            }}
                        />

                    </div>

                </div>

            </div>

        </div>
    );
}

export default AllProcessingFailureLog;
